import React, { FC } from 'react'
import { SimpleForm, CreateProps, Create } from 'react-admin'

import { makeStyles } from '@material-ui/core/styles'

import { FormProvider } from 'contexts/FormProvider'

import { Form } from './containers'

const useStyles = makeStyles({
  container: {
    padding: 8,
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
    padding: 0,
    justifyContent: 'center',
  },
})

export const CreateSlider: FC<CreateProps> = (props: any) => {
  const classes = useStyles()
  return (
    <Create {...props}>
      <SimpleForm
        title="Criar Slide"
        warnWhenUnsavedChanges
        className={classes.formContainer}
        initialValues={{
          type: 'banner-full',
          images: [
            { type: 'banner' },
            { type: 'logo' },
            { type: 'banner-mobile' },
          ],
        }}
      >
        <FormProvider>
          <Form />
        </FormProvider>
      </SimpleForm>
    </Create>
  )
}
